<template>
  <div class="container">
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="copyright d-flex align-items-center justify-content-start">
          <p>© {{ new Date().getFullYear() }} Məlumat Portalı</p>
        </div>
      </div>
      <div class="col-6 col-md-4 d-none d-sm-block">
        <div class="d-flex justify-content-center">
          <a
            href="https://play.google.com/store/apps/details?id=az.local.pwa"
            target="_blank"
            @click="googlePlay"
          >
            <img src="static/google-play.webp" alt="" class="google-play" />
          </a>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="social d-flex align-items-center justify-content-end">
          <p>Bizi izləyin:</p>
          <a
            href="https://www.facebook.com/azelocal/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="static/facebook.svg" alt="facebook" />
          </a>
          <a
            href="https://www.instagram.com/azelocal/"
            target="_blank"
            rel="noreferrer"
          >
            <img src="static/instagram.svg" alt="instagram" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    googlePlay() {
      this.$ga.event("googlePlay", "click", "googlePlayFooter", 1);
    },
  },
};
</script>

<style scoped>
* {
  color: #333;
}
.social {
  justify-content: flex-end !important;
}
.social img {
  width: 24px;
  height: auto;
  margin-left: 1rem;
  display: block;
}

@media only screen and (max-width: 768px) {
  .social {
    font-size: 12px;
  }
  .copyright {
    font-size: 12px;
  }
  .social img {
    width: 18px;
    height: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue